module.exports = __webpack_public_path__ + "fonts/BebasNeue Bold.a6a8df39.otf";